import { withInstall } from '../../utils/install';
import Chip from './index.vue';

export const IvueChip = withInstall(Chip);
export default IvueChip;

export * from './index.vue';
